@if (isRouterPathUnauthorized() || isRouterPathNotFound()) {
    <div class="h-screen">
        <router-outlet />
    </div>
} @else {
    <div class="relative h-screen w-screen overflow-hidden">
        <app-moving-background />
        <div class="relative z-10 flex h-full flex-col p-6 pt-0">
            <app-header></app-header>
            <main
                id="main-content"
                tabindex="-1"
                class="relative min-h-0 w-full flex-1 overflow-clip rounded-3xl border border-white/10 bg-[rgba(33,33,58,0.5)] backdrop-blur-[13px]"
            >
                <router-outlet></router-outlet>
            </main>
        </div>
    </div>
}
